module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5aESS"))).then(() => parcelRequire('cvs7o'));